import { useNavigation } from '@react-navigation/native'
import React from 'react'
import { Pressable } from 'react-native'

import { Avatar } from 'widgets/Avatar'
import { defaultAvatarImage } from 'widgets/Avatar/defaultAvatarImage'
import { Box } from 'widgets/Box'
import { Text } from 'widgets/Text'

import { useCurrentUser } from 'hooks/useCurrentUser'

import { links } from 'utils/constants'
import { timeSince } from 'utils/time'

import { Room } from 'types/chat'

interface ChatRoomRowProps {
  room: Room
}

export const ChatRoomRow = ({ room }: ChatRoomRowProps) => {
  const { data: currentUser } = useCurrentUser()
  const lastTimestamp = room.lastMessage?.created || room.created
  const navigation = useNavigation<any>()
  const userAvatars = room.avatarUsers.filter((avatarUser) => avatarUser.id !== currentUser?.id)

  // Get the name of the other user to show as the chat room name.
  // Note: This won't work for group chats
  const otherUsers = room.avatarUsers.filter(
    (avatarUser) => avatarUser.username !== currentUser?.username,
  )

  const roomName =
    otherUsers.length > 0 ? `${otherUsers[0].firstName} ${otherUsers[0].lastName}` : 'Chat'

  return (
    <Pressable onPress={() => navigation.navigate(links.CHAT_ROOM, { roomId: room.id })}>
      <Box flexDirection='row'>
        <Box padding={{ vertical: 'md', right: 'md' }}>
          <Avatar width={64} height={64} image={userAvatars[0]?.avatar ?? defaultAvatarImage} />
        </Box>
        <Box
          flex={1}
          flexDirection='column'
          justifyContent='flex-start'
          margin={{ top: 'md', right: 'sm' }}
        >
          <Box flexDirection='row' align='center'>
            <Box flex={1} margin={{ right: 'xs' }}>
              <Text bold fontSize='sm' numberOfLines={1}>
                {roomName}
              </Text>
            </Box>
            <Text fontSize='xs' color='greyDarker' numberOfLines={1}>
              {timeSince(lastTimestamp)}
            </Text>
          </Box>
          <Box flex={1} flexDirection='column' justifyContent='flex-start'>
            <Box flexDirection='row' align='center'>
              <Box flex={1}>
                <Text numberOfLines={2} color='greyDarkest' fontSize='sm'>
                  {room.lastMessage?.body.length
                    ? room.lastMessage?.body
                    : 'There are no messages yet.'}
                </Text>
              </Box>
              {room.meta?.newMessageCount ? (
                <Box
                  backgroundColor='v2primary'
                  borderRadius='xl'
                  align='flex-end'
                  width={10}
                  height={10}
                />
              ) : null}
            </Box>
          </Box>
        </Box>
      </Box>
    </Pressable>
  )
}
